module.exports = __webpack_public_path__ + "img/11.ad583735.png";